import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { ProgressActionType, ProgressStoreList } from './ProgressReducer.types';

const initialState = Immutable.List();

export const ProgressReducer = handleActions<any>(
  {
    REQUEST_PROGRESS_SIMULATE: (state: ProgressStoreList, action: ProgressActionType) => {
      const index = state.findIndex((item: any) => item.get('id') === action.payload.idParent);
      if (index >= 0) {
        return state.setIn([index, 'fetchingPercentage'], true);
      } else {
        return state;
      }
    },

    RESPONSE_PROGRESS_SIMULATE_SUCCESS: (state: ProgressStoreList, action: ProgressActionType) => {
      const index = state.findIndex((item: any) => item.get('id') === action.payload.idParent);
      if (index >= 0) {
        return state.setIn([index, 'percentageProgress'], action.payload.percentage);
      } else {
        return state;
      }
    },
    CHANGE_TAB_POSITION: (state: ProgressStoreList, action: ProgressActionType) => {
      const tabToChange = state.get(action.payload.source);
      if (tabToChange) {
        return state.delete(action.payload.source).insert(action.payload.destination, tabToChange);
      } else {
        return state;
      }
    },
    RESPONSE_PROGRESS_SIMULATE_FAILURE: (state: ProgressStoreList, action: ProgressActionType) => {
      const index = state.findIndex((item: any) => item.get('id') === action.payload.idParent);
      if (index >= 0) {
        return state.map((el: any, key: number) => {
          if (index === key) {
            return el.merge(
              Immutable.fromJS({
                percentageProgress: 0.0,
                fetchingPercentage: false,
                fetchingPost: false,
                fetchingCancel: false,
                hasFailed: true,
                cancel: false,
                showLearnBox: true,
              })
            );
          } else {
            return el;
          }
        });
      } else {
        return state;
      }
    },
    RESPONSE_PROGRESS_SIMULATE_COMPLETE: (state: ProgressStoreList, action: ProgressActionType) => {
      const index = state.findIndex((item: any) => item.get('id') === action.payload.idParent);
      if (index >= 0) {
        return state.map((el: any, key: number) => {
          if (index === key) {
            return el.merge(
              Immutable.fromJS({
                percentageProgress: 0.0,
                fetchingPercentage: false,
                fetchingPost: false,
                fetchingCancel: false,
                hasFailed: false,
                cancel: false,
                showLearnBox: true,
              })
            );
          } else {
            return el;
          }
        });
      } else {
        return state;
      }
    },
    REQUEST_SIMULATION_POST: (state: ProgressStoreList, action: ProgressActionType) => {
      const index = state.findIndex((item: any) => item.get('id') === action.payload.idParent);
      if (index >= 0) {
        return state.setIn([index, 'fetchingPost'], true).setIn([index, 'hasFailed'], false).setIn([index, 'simulationId'], undefined);
      } else {
        return state;
      }
    },

    RESPONSE_SIMULATION_SUCCESS: (state: ProgressStoreList, action: ProgressActionType) => {
      const index = state.findIndex((item: any) => item.get('id') === action.payload.idParent);
      if (index >= 0) {
        return state.setIn([index, 'fetchingPost'], false).setIn([index, 'simulationId'], action.payload.data);
      } else {
        return state;
      }
    },

    RESPONSE_SIMULATION_FAILURE: (state: ProgressStoreList, action: ProgressActionType) => {
      const index = state.findIndex((item: any) => item.get('id') === action.payload.idParent);
      if (index >= 0) {
        return state.setIn([index, 'fetchingPost'], false).setIn([index, 'hasFailed'], true);
      } else {
        return state;
      }
    },

    CLONE_ALPHA_FROM_CONTENT: (state: ProgressStoreList, action: ProgressActionType) =>
      state.push(
        // @ts-ignore
        Immutable.fromJS({
          percentageProgress: 0.0,
          fetchingPercentage: false,
          fetchingPost: false,
          fetchingCancel: false,
          cancel: false,
          hasFailed: false,
          showLearnBox: true,
          id: action.payload.idParent,
        })
      ),

    CHANGE_TO_MULTI_TAB: (state: ProgressStoreList, action: ProgressActionType) =>
      state.map((el: any, index: number) => {
        if (index === action.payload.tabIndex) {
          return el.merge(
            Immutable.fromJS({
              id: action.payload.idParent,
            })
          );
        } else {
          return el;
        }
      }),

    CLONE_ALPHA: (state: ProgressStoreList, action: ProgressActionType) => {
      if (action.payload.indexChild === null) {
        return state.push(
          // @ts-ignore
          Immutable.fromJS({
            percentageProgress: 0.0,
            fetchingPercentage: false,
            fetchingPost: false,
            fetchingCancel: false,
            cancel: false,
            hasFailed: false,
            showLearnBox: true,
            id: action.payload.idParent,
          })
        );
      } else {
        return state;
      }
    },

    CREATE_NEW_TAB: (state: ProgressStoreList, action: ProgressActionType) =>
      state.push(
        // @ts-ignore
        Immutable.fromJS({
          percentageProgress: 0.0,
          fetchingPercentage: false,
          fetchingPost: false,
          fetchingCancel: false,
          cancel: false,
          hasFailed: false,
          showLearnBox: true,
          id: action.payload.idParent,
        })
      ),
    CREATE_NEW_SUPER_ALPHA_TAB: (state: ProgressStoreList, action: ProgressActionType) =>
      state.push(
        // @ts-ignore
        Immutable.fromJS({
          percentageProgress: 0.0,
          fetchingPercentage: false,
          fetchingPost: false,
          fetchingCancel: false,
          cancel: false,
          hasFailed: false,
          showLearnBox: true,
          id: action.payload.idParent,
        })
      ),
    CREATE_NEW_MULTI_TAB: (state: ProgressStoreList, action: ProgressActionType) =>
      state.push(
        // @ts-ignore
        Immutable.fromJS({
          percentageProgress: 0.0,
          fetchingPercentage: false,
          fetchingPost: false,
          fetchingCancel: false,
          cancel: false,
          hasFailed: false,
          showLearnBox: true,
          id: action.payload.idParent,
        })
      ),
    HIDE_LEARN_BOX: (state: ProgressStoreList, action: ProgressActionType) => {
      const index = state.findIndex((item: any) => item.get('id') === action.payload.idParent);
      if (index >= 0) {
        return state.setIn([index, 'showLearnBox'], false);
      } else {
        return state;
      }
    },
    CLOSE_TAB: (state: ProgressStoreList, action: ProgressActionType) => state.remove(action.payload.tabIndex),
    CANCEL_SIMULATION_REQUEST: (state: ProgressStoreList, action: ProgressActionType) => {
      const index = state.findIndex((item: any) => item.get('id') === action.payload.idParent);
      if (index >= 0) {
        return state.setIn([index, 'fetchingCancel'], true);
      } else {
        return state;
      }
    },
    CANCEL_SIMULATION_SUCCESS: (state: ProgressStoreList, action: ProgressActionType) => {
      const index = state.findIndex((item: any) => item.get('id') === action.payload.idParent);
      if (index >= 0) {
        return state.setIn([index, 'cancel'], true).setIn([index, 'simulationId'], undefined);
      } else {
        return state;
      }
    },
    CANCEL_SIMULATION_FAILURE: (state: ProgressStoreList, action: ProgressActionType) => {
      const index = state.findIndex((item: any) => item.get('id') === action.payload.idParent);
      if (index >= 0) {
        return state.setIn([index, 'fetchingCancel'], false).setIn([index, 'hasFailed'], true);
      } else {
        return state;
      }
    },
    CANCEL_SIMULATION_DONE: (state: ProgressStoreList, action: ProgressActionType) => {
      const index = state.findIndex((item: any) => item.get('id') === action.payload.idParent);
      if (index >= 0) {
        return state.setIn([index, 'fetchingCancel'], false).setIn([index, 'cancel'], false);
      } else {
        return state;
      }
    },
    CLEAN_PROGRESS: (state: ProgressStoreList) =>
      state.map((elment: any) =>
        elment.merge(
          Immutable.fromJS({
            percentageProgress: 0.0,
            fetchingPercentage: false,
            fetchingPost: false,
            fetchingCancel: false,
            cancel: false,
            hasFailed: false,
            showLearnBox: true,
          })
        )
      ),
    AUTHENTICATION_LOGOUT: () => initialState,
  },
  initialState
);
